module.exports = {
  types: [
    { name: 'not_started', value: 'Not Started' },
    { name: 'finalized', value: 'Completed' },
    { name: 'awaiting_cosign', value: 'Awaiting Co-Sign' },
    { name: 'draft', value: 'Draft' }
  ]
};
